var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeCustomerCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#001838"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 64,
    height: 64,
    rx: 32,
    stroke: "#64B3E1",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1999 37.6001C44.7833 36.1834 45.0999 34.6667 45.0999 33.0001C45.0999 31.8001 44.9166 30.6501 44.5999 29.5834C43.5166 29.8334 42.3833 29.9667 41.1999 29.9667C38.7765 29.9693 36.388 29.3893 34.2358 28.2754C32.0836 27.1616 30.2306 25.5467 28.8333 23.5667C27.3384 27.1837 24.5185 30.0931 20.9499 31.7001C20.8833 32.1167 20.8833 32.5667 20.8833 33.0001C20.8833 34.5913 21.1967 36.1669 21.8056 37.6369C22.4145 39.107 23.307 40.4427 24.4321 41.5679C26.7045 43.8402 29.7864 45.1167 32.9999 45.1167C34.7499 45.1167 36.4333 44.7334 37.9499 44.0501C38.8999 45.8667 39.3333 46.7667 39.2999 46.7667C36.5666 47.6834 34.4499 48.1334 32.9999 48.1334C28.9666 48.1334 25.1166 46.5501 22.2833 43.7001C20.5599 41.982 19.2789 39.8717 18.5499 37.5501H16.3333V29.9667H18.1499C18.7003 27.2876 19.9657 24.8074 21.8119 22.7894C23.6581 20.7714 26.0161 19.2908 28.6358 18.5047C31.2555 17.7186 34.0391 17.6564 36.6914 18.3246C39.3436 18.9928 41.7654 20.3666 43.6999 22.3001C45.8003 24.3922 47.2329 27.0602 47.8166 29.9667H49.6666V37.5501H49.5666L43.6332 43.0001L34.7999 42.0001V39.2167H42.8499L44.1999 37.6001ZM28.4499 32.6167C28.9499 32.6167 29.4333 32.8167 29.7833 33.1834C30.135 33.538 30.3324 34.0173 30.3324 34.5167C30.3324 35.0162 30.135 35.4955 29.7833 35.8501C29.4333 36.2001 28.9499 36.4001 28.4499 36.4001C27.3999 36.4001 26.5499 35.5667 26.5499 34.5167C26.5499 33.4667 27.3999 32.6167 28.4499 32.6167ZM37.5333 32.6167C38.5833 32.6167 39.4166 33.4667 39.4166 34.5167C39.4166 35.5667 38.5833 36.4001 37.5333 36.4001C36.4833 36.4001 35.6333 35.5667 35.6333 34.5167C35.6333 34.0128 35.8334 33.5296 36.1897 33.1732C36.5461 32.8169 37.0293 32.6167 37.5333 32.6167Z",
    fill: "#ECF6FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCustomerCare);
export default __webpack_public_path__ + "static/media/home-customer-care.0ced94f1563dedb7bcd64adbb1979929.svg";
export { ForwardRef as ReactComponent };